import { useState, useEffect } from 'react';

const Donut = ({ cleanerThan }) => {
    const [percent, setPercent] = useState(1);

    useEffect(() => {
        const timer = setTimeout(() => {
            setPercent(cleanerThan);
        }, 100);
        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            <div className={"c-donut c-donut--" + percent}>
                <div className="c-donut__outer">
                    <div className="c-donut__inner">
                        <div className="c-donut__text">
                            <p className="c-donut__value">{cleanerThan}%</p>
                            <p className="c-donut__subtitle"></p>
                        </div>
                    </div>
                </div>               
            </div>
        </>
    );
}

export default Donut;